module.exports = __webpack_public_path__ + "img/thumb-songspace2a.535f2239.jpg";